
import ClaimCheckTerms from '@/components/ClaimCheckTerms.vue';
import EmailReceiptModal from '@/components/EmailReceiptModal.vue';
import MarkdownText from '@/components/MarkdownText.vue';
import MembershipModal from '@/components/MembershipModal.vue';
import ReceiptModal from '@/components/ReceiptModal.vue';
import ShuttleTrackerWidget from '@/components/ShuttleTracker.vue';
import RequestDisabledModal from '@/components/RequestDisabledModal.vue';
import RequestModal from '@/components/RequestModal.vue';
import { ClaimCheck as ClaimCheckModel, Vehicle } from '@/models';
import { differenceInHours, parse } from 'date-fns';
import has from 'lodash/fp/has';
import { Component, Vue } from 'vue-property-decorator';
import VueQriously from 'vue-qriously';
import { mapActions, mapGetters, mapState } from 'vuex';
import Fetch from '@/utilities/Fetch';

Vue.use(VueQriously);

@Component({
	name: 'ClaimCheck',
	components: {
		ClaimCheckTerms,
		EmailReceiptModal,
		MarkdownText,
		MembershipModal,
		ReceiptModal,
		RequestDisabledModal,
		RequestModal,
		ShuttleTrackerWidget,
	},
	computed: {
		...mapGetters(['location', 'logo', 'subLocation', 'ticket']),
		...mapState('claimCheck', [
			'claimCheck',
			'vehicle',
		]),
	},
	methods: {
		...mapActions('claimCheck', [
			'fetchClaimCheck',
			'fetchVehicle',
		]),
	},
})
export default class ClaimCheck extends Vue {
	public requestedDate: string = '';
	public viewingMembership: boolean = false;
	public viewingReceipt: boolean = false;

	// Vuex
	public claimCheck!: ClaimCheckModel;
	public vehicle!: Vehicle;
	public settings!: any;
	public location!: number | string;
	public logo!: string;
	public subLocation!: number | string;
	public ticket!: string;
	public fetchClaimCheck!: (payload: any) => Promise<ClaimCheckModel>;
	public fetchVehicle!: (payload: any) => Promise<Vehicle>;
	public trackerUrl!: string;
	public validUrl: boolean = false;

	public get actionStyle(): string {
		if (this.claimCheck.paid && !this.claimCheck.requested && this.claimCheck.close_date) {
			return 'items-end';
		}

		if (this.claimCheck.paid && this.claimCheck.requested && this.claimCheck.close_date) {
			return 'items-center';
		}

		if (this.claimCheck.paid && !this.claimCheck.requested) {
			return 'items-center';
		}

		if (!this.claimCheck.paid) {
			return 'items-center';
		}

		return 'items-end';
	}

	public confirmation_message(message: any): any {
		if (message && message.includes('[TERMINAL NOTES]')) {
			message = message.replace('[TERMINAL NOTES]', '');

			if (this.claimCheck.terminals) {
				this.claimCheck.terminals.forEach(terminal => {
					if (terminal.terminal === this.claimCheck.terminal_selected) {
						message = message + ' ' + terminal.terminal_notes;
					}
				});
			}
		}
		return message;
	}

	public get token(): string {
		return this.$store.state.token;
	}

	public get balanceDue(): number {
		return has('receipt.balance_due', this.claimCheck)
			? this.claimCheck.receipt.balance_due
			: this.claimCheck.receipt.total;
	}

	public get hasPayment(): boolean {
		return this.claimCheck.paid &&
			!!this.claimCheck.payment_date &&
			!!this.claimCheck.payment_amount;
	}

	public get paymentRequired(): boolean {
		return this.claimCheck.pay_by_phone && this.balanceDue > 0;
	}

	public get isPaid(): boolean {
		return (this.hasPayment && !this.balanceDue) || (this.claimCheck.paid && this.claimCheck.close_date !== null);
	}

	public get isRequestDisabled(): boolean {
		return (
			!this.claimCheck.payment_date &&
			!this.claimCheck.request_before_payment
		);
	}

	public get showRequest(): boolean {
		return (this.claimCheck.request_car && !this.claimCheck.requested_time) ||
			(this.claimCheck.request_shuttle && !this.claimCheck.requested_time) ||
			this.showRequestMessage;
	}

	public get showRequestAfterPayment(): boolean {
		return this.$store.state.processedPayment && this.showRequest && !this.claimCheck.requested_time;
	}

	public get showRequestMessage(): boolean {
		if (!this.claimCheck.requested_time) {
			return false;
		}

		const currentDate = new Date();
		const requestedTime = parse(this.claimCheck.requested_time);

		if (differenceInHours(currentDate, requestedTime) >= 2) {
			return false;
		}

		return true;
	}

	public async created() {
		if (!this.ticket) {
			this.$router.replace({ name: 'error' });
		}

		try {
			await this.fetchClaimCheck({ url: `/claim/${this.ticket}` });
		} catch (errors) {
			this.$router.replace({ name: 'error' });
		}

		// try {
		//	await this.fetchVehicle({ url: `/claim/${this.ticket}/vehicle` });
		// } catch (errors) {
		//	this.$router.replace({ name: 'error' });
		// }

		try {
			this.settings = await Fetch.get(`/api/checkin/${this.token}`);
			if (this.settings.eparking_settings.shuttle_tracker_url) {
				this.trackerUrl = this.settings.eparking_settings.shuttle_tracker_url;
				this.validUrl = true;
			}
		} catch (errors) {
			this.$router.replace({ name: 'error' });
		}

		if (this.showRequestAfterPayment) {
			this.handleRequest();
		}

		if (this.$route.query.checkin) {
			this.$modal.show('CheckinModal');
		}

		if (this.claimCheck.rewards_required && !this.claimCheck.rewards_description) {
			this.$modal.show('MembershipModal');
		}
	}

	public displayRequestMessage(requestedDate: string) {
		this.requestedDate = requestedDate;
	}

	public handleRequest() {
		if (this.isRequestDisabled) {
			this.$modal.show('RequestDisabledModal');

			return false;
		}

		this.$modal.show('RequestModal');
	}

	public handleMembership() {
		this.$modal.show('MembershipModal');
	}
}
